import { makeStyles } from '@mui/styles'
import {
  ERROR,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
} from '@returnmates/client-core/src/constants/colors'

import { POPPINS } from '../../constants/styles/fonts'

const useStyles = makeStyles(() => ({
  input: {},
  inputField: {
    fontFamily: POPPINS,
    color: MIDNIGHT_EXPRESS,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '160%',
  },
  dateInput: {},
  errorHandler: {
    position: 'relative',
    fontFamily: POPPINS,
    fontSize: 14,
    color: ERROR,
  },
  helperText: {
    position: 'absolute',
    top: '100%',
    left: 0,
  },
  wrapper: {
    position: 'relative',
  },
  calendarWrapper: {
    transform: 'scale(0.75)',
    transformOrigin: 'top left',
    width: 'fit-content',
    position: 'absolute',
    zIndex: 1300,
    backgroundColor: 'white',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    borderRadius: '4px',
    marginTop: '4px',
  },
  staticWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  staticDayPicker: {
    margin: '0 auto',
  },
  dayPicker: {
    fontFamily: POPPINS,
    '& .DayPicker-Day--selected': {
      backgroundColor: 'rgba(99, 93, 246, 0.1) !important',
      color: `${NEON_BLUE_LIGHT} !important`,
      fontWeight: 600,
      border: `1px solid ${NEON_BLUE_LIGHT} !important`,
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: 'rgba(99, 93, 246, 0.15) !important',
      },
    },
    '& .DayPicker-Day.selected': {
      backgroundColor: 'rgba(99, 93, 246, 0.1) !important',
      color: `${NEON_BLUE_LIGHT} !important`,
      fontWeight: 600,
      border: `1px solid ${NEON_BLUE_LIGHT} !important`,
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: 'rgba(99, 93, 246, 0.15) !important',
      },
    },
    // Today's date
    '& .DayPicker-Day--today': {
      fontWeight: 600,
    },
    '& .DayPicker-Day.today': {
      fontWeight: 600,
    },
    // Hover styles
    '& .DayPicker-Day:hover:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.selected)': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    // Disabled date styles
    '& .DayPicker-Day--disabled': {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    '& .DayPicker-Day.disabled': {
      opacity: 0.4,
      cursor: 'not-allowed',
    },
    // Make calendar elements smaller
    '& .DayPicker': {
      fontSize: '11px',
    },
    '& .DayPicker-Day': {
      fontSize: '11px',
      padding: '4px',
      width: '26px',
      height: '26px',
      lineHeight: '18px',
    },
    '& .DayPicker-Weekday': {
      fontSize: '10px',
      padding: '3px',
      fontWeight: 500,
    },
    '& .DayPicker-Caption': {
      fontSize: '12px',
      padding: '6px',
      fontWeight: 600,
    },
    '& .DayPicker-NavButton': {
      width: '20px',
      height: '20px',
      top: '8px',
    },
    '& .DayPicker-Week': {
      margin: '2px 0',
    },
    '& .DayPicker-Month': {
      margin: '0 4px',
    },
  },
}))

export default useStyles
